import flexiride from '../../../endpoints/flexiride';
import Repository from './repository';

const client = new Repository();

export default {
  async editRequest(id, token) {
    const r = client.get(`${flexiride.edit}/${id}?token=${token}`);
    return r;
  },

  async approveRequest(id, token) {
    const r = client.get(`${flexiride.approve}/${id}?token=${token}`);
    return r;
  },

  async getRequest(id, token) {
    const r = client.get(`${flexiride.request}/${id}`, { token });
    return r;
  },

  async getEvents(routeDay, regionId, depotId) {
    // ?routeDay = 2023 - 04 - 06 & regionId=17152501 & depotId=17158001
    const r = client.get(`${flexiride.events}`, { routeDay, regionId, depotId });
    return r;
  },

  async getEventsInDateRange(routeDay, endDate, type) {
    const params = { routeDay, endDate };

    if (type) {
      params.type = type;
    }

    const r = client.get(`${flexiride.events}`, params);
    return r;
  },

  async updateEvents(payload) {
    const r = await client.post(flexiride.events, payload);
    return r;
  },

  async approveDraft(resourceId, payload) {
    const r = await client.post(flexiride.approveDraft.replace(':resourceId', resourceId), payload);
    return r;
  },

  async recommendRoute(payload) {
    const r = await client.get(flexiride.recommendRoute, payload);
    return r;
  },

  async track(regionId, depotId, routeDay) {
    const r = await client.get(flexiride.track, { regionId, depotId, routeDay });
    return r;
  },

  async getUsers() {
    const r = await client.get(flexiride.flexirideUsers);
    return r;
  },
  async getSharedRideUsers(type) {
    const r = await client.get(flexiride.sharedrideUsers, { type });
    return r;
  },

  async insertOrder(payload) {
    const r = await client.post(flexiride.insertOrder, payload);
    return r;
  },

  async moveOrder(payload) {
    const r = await client.post(flexiride.moveOrder, payload);
    return r;
  },

  async saveExtend(orderId, payload) {
    const r = await client.post(`${flexiride.saveExtend}/${orderId}/extend`, payload);
    return r;
  },
  async extend(orderId) {
    const r = await client.get(`${flexiride.saveExtend}/${orderId}/extend-limit`);
    return r;
  },

  async getPairRules(requestType) {
    const r = await client.get(`${flexiride.pairRules}?requestType=${requestType}`);
    return r;
  },

  optimization: {
    async autoPlanAsync(payload) {
      const r = await client.post(flexiride.optimization.autoPlanAsync, payload);
      return r;
    },
    async getLatestSolution(optimizationId) {
      const r = await client.get(flexiride.optimization.latestSolution.replace(':optimizationId', optimizationId));
      return r;
    },
    async importOptimization(optimizationId) {
      const r = await client.post(flexiride.optimization.import.replace(':optimizationId', optimizationId));
      return r;
    },
  },
  dashboard: {
    async request() {
      const r = await client.get(flexiride.dashboard.request);
      return r;
    },
    async activatedRequests() {
      const r = await client.get(flexiride.dashboard.activatedRequests);
      return r;
    },
    async summary(startDate, endDate) {
      const r = await client.get(flexiride.dashboard.summary, { startDate, endDate });
      return r;
    },
    async byDate(startDate, endDate) {
      const r = await client.get(flexiride.dashboard.byDate, { startDate, endDate });
      return r;
    },
    async pickupOnTimePerformance(startDate, endDate) {
      const r = await client.get(flexiride.dashboard.pickupOnTimePerformance, { startDate, endDate });
      return r;
    },
    async deliveryOnTimePerformance(startDate, endDate) {
      const r = await client.get(flexiride.dashboard.deliveryOnTimePerformance, { startDate, endDate });
      return r;
    },
    async drivers() {
      const r = await client.get(flexiride.dashboard.drivers);
      return r;
    },
    async vehicles() {
      const r = await client.get(flexiride.dashboard.vehicles);
      return r;
    },
    async driverUtilization(startDate, endDate) {
      const r = await client.get(flexiride.dashboard.driverUtilization, { startDate, endDate });
      return r;
    },
    async vehicleUtilization(startDate, endDate) {
      const r = await client.get(flexiride.dashboard.vehicleUtilization, { startDate, endDate });
      return r;
    },
    async emissions(startDate, endDate) {
      const r = await client.get(flexiride.dashboard.emissions, { startDate, endDate });
      return r;
    },
  },
};
